/**
 * ⚠️⚠️⚠️⚠️
 * Not in TS but it's normal. It has been removed (SP-6643).
 * But still in JS to be visible in analytics for a moment.
 */

import { StrategyBaseClass } from './strategy-base-class.js'


export class GbmService extends StrategyBaseClass {
  constructor($translate) {
    super($translate);
  }

  getType() {
    return 14;
  }
  getTypeString() {
    return 'gbm';
  }
  getAllTasksTypes() {
    return [39];
  }
  getPublicTaskTypes() {  // For favorites filtering
    return [];
  }
  getPrivateTaskTypes() {
    return [39];
  }
  getTaskTypeString(taskType) {
    let mapping = {
      39: 'gbm/msg'
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType) {
    let mapping = {
      39: 'gbm-msg'
    };
    return mapping[taskType];
  }

  canHaveSurveys() {
    return false;
  }

  getEditorConfiguration(isPrivate) {
    return {
      'pictureEnabled': true,
      'imageMimeTypes': 'image/*'
    };
  }

  getQuickRepliesElementsConfig() {
    return {
      maxAnswerNb: 11,
      answerLabelMaxLength: 20,
      hasDescription: false,
      canHaveUserVariableInRootQuestion: false,
      hasPhoneEmailAnswerType: false,
      hasTargetAppId: false,
      boxesCanBeTested: false,
      hasPersistentMenu: false,
      hasWelcomeMessage: false,
      imageMimeTypes: 'image/*',
      editorConfiguration: {
        fileEnabled: false,
        hasImageControl: false
      },
      sendTextAfterButtonChoice: false,
      canSendVideo: true
    };
  }

  static GbmFactory($translate) {
    return new GbmService($translate);
  }
}
GbmService.GbmFactory.$inject = ['$translate'];
